export const KeyboardConstants = {
    // KeyboardEvent key constants
    Backspace: "Backspace",
    Comma: "Comma",
    Delete: "Delete",
    DownArrow: "ArrowDown",
    End: "End",
    Enter: "Enter",
    Escape: "Escape",
    Home: "Home",
    LeftArrow: "ArrowLeft",
    RightArrow: "ArrowRight",
    Space: " ",
    Tab: "Tab",
    UpArrow: "ArrowUp",
};
